<template>
  <div class="active-filters wrap">
    <p v-show="showLabel" class="visible-md active-filters-title w-100 m0 py10">
      {{ $t('Active filters') }}:
    </p>
    <div
      v-for="(filter, filterIndex) in filters"
      :key="filterIndex"
      class="flex middle-xs wrap"
    >
      <template v-if="isFiltersAreArrays()">
        <span
          v-for="(option, index) in filter"
          :key="index"
          :class="{'margin-bottom': stylesSidebarMobile}"
          class="active-label pointer brdr-1 brdr-cl-secondary-gray py10 px15 h5 active-label cl-light-gray flex middle-xs center-xs mr15 mb5 uppercase"
          @click="$emit('change', option)"
        >
          {{ option.label }}
          <i class="icon-close h6 ml10" />
        </span>
      </template>
      <template v-else>
        <span
          @click="$emit('change', filter)"
          class="pointer uppercase active-filter-label"
        >
          <span class="cl-silver">{{ filter.label }}</span>
          <i class="icon-close h6 ml10" />
        </span>
      </template>
    </div>
    <div>
      <span @click="clearWordFilter()" v-if="queryByWord" :class="{'margin-bottom': stylesSidebarMobile}" class="active-label pointer brdr-1 brdr-cl-secondary-gray py10 px15 h5 active-label cl-light-gray flex middle-xs center-xs mr15 mb5">
        Szukasz: {{ queryByWord }}
        <i class="icon-close h6 ml10" />
      </span>
    </div>
    <div>
      <span @click="toggleSaleFilter()" v-if="isSaleFilterActive" :class="{'margin-bottom': stylesSidebarMobile}" class="active-label pointer brdr-1 brdr-cl-secondary-gray py10 px15 h5 active-label cl-light-gray flex middle-xs center-xs mr15 mb5">
        {{ $t('Sale') }}
        <i class="icon-close h6 ml10" />
      </span>
    </div>
    <div>
      <span @click="toggleNewFilter()" v-if="isNewFilterActive" :class="{'margin-bottom': stylesSidebarMobile}" class="active-label pointer brdr-1 brdr-cl-secondary-gray py10 px15 h5 active-label cl-light-gray flex middle-xs center-xs mr15 mb5">
        {{ $t('New') }}
        <i class="icon-close h6 ml10" />
      </span>
    </div>
    <div>
      <span @click="toggleBestselleryFilter()" v-if="isBestselleryFilterActive" :class="{'margin-bottom': stylesSidebarMobile}" class="active-label pointer brdr-1 brdr-cl-secondary-gray py10 px15 h5 active-label cl-light-gray flex middle-xs center-xs mr15 mb5">
        {{ $t('Bestsellers') }}
        <i class="icon-close h6 ml10" />
      </span>
    </div>
    <div>
      <span @click="toggleSubscriptionFilter()" v-if="isSubscriptionFilterActive" :class="{'margin-bottom': stylesSidebarMobile}" class="active-label pointer brdr-1 brdr-cl-secondary-gray py10 px15 h5 active-label cl-light-gray flex middle-xs center-xs mr15 mb5">
        {{ $t('Available in subscription') }}
        <i class="icon-close h6 ml10" />
      </span>
    </div>
    <div>
      <span @click="toggleShowroomFilter()" v-if="isShowroomFilterActive" :class="{'margin-bottom': stylesSidebarMobile}" class="active-label pointer brdr-1 brdr-cl-secondary-gray py10 px15 h5 active-label cl-light-gray flex middle-xs center-xs mr15 mb5">
        {{ $t('Available in showroom') }}
        <i class="icon-close h6 ml10" />
      </span>
    </div>
    <div>
      <span @click="toggleVideoFilter()" v-if="isVideoFilterActive" :class="{'margin-bottom': stylesSidebarMobile}" class="active-label pointer brdr-1 brdr-cl-secondary-gray py10 px15 h5 active-label cl-light-gray flex middle-xs center-xs mr15 mb5">
        {{ $t('Available in showroom') }}
        <i class="icon-close h6 ml10" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActiveFilters',
  props: {
    filters: {
      type: Object,
      required: true
    },
    showLabel: {
      type: Boolean,
      required: false
    },
    stylesSidebarMobile: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    queryByWord () {
      return this.$route.query && this.$route.query.query ? this.$route.query.query : null
    },
    isSaleFilterActive () {
      return this.$store.state.ui.isSaleFilterActive
    },
    isNewFilterActive () {
      return this.$store.state.ui.isNewFilterActive
    },
    isBestselleryFilterActive () {
      return this.$store.state.ui.isBestselleryFilterActive
    },
    isSubscriptionFilterActive () {
      return this.$store.state.ui.isSubscriptionFilterActive
    },
    isShowroomFilterActive () {
      return this.$store.state.ui.isShowroomFilterActive
    },
    isVideoFilterActive () {
      return this.$store.state.ui.isVideoFilterActive
    }
  },
  methods: {
    clearWordFilter () {
      let query = Object.assign({}, this.$route.query)
      if (this.queryByWord) {
        delete query.query
        this.$router.push({ query })
      }
    },
    toggleSaleFilter () {
      let query = Object.assign({}, this.$route.query)
      this.$store.dispatch('ui/toggleSaleFilter').then(() => {
        if (!this.isSaleFilterActive) {
          delete query.sale
          this.$router.push({ query })
        } else {
          query.sale = 'true'
          this.$router.push({ query })
        }
      })
    },
    toggleNewFilter () {
      let query = Object.assign({}, this.$route.query)
      this.$store.dispatch('ui/toggleNewFilter').then(() => {
        if (!this.isNewFilterActive) {
          delete query.new
          delete query.sort
          this.$router.push({ query })
        } else {
          query.new = 'true'
          query.sort = 'id:desc'
          this.$router.push({ query })
        }
      })
    },
    toggleBestselleryFilter () {
      let query = Object.assign({}, this.$route.query)
      this.$store.dispatch('ui/toggleBestselleryFilter').then(() => {
        if (!this.isBestselleryFilterActive) {
          delete query.bestsellery
          this.$router.push({ query })
        } else {
          query.bestsellery = 'true'
          this.$router.push({ query })
        }
      })
    },
    toggleSubscriptionFilter () {
      let query = Object.assign({}, this.$route.query)
      this.$store.dispatch('ui/toggleSubscriptionFilter').then(() => {
        if (!this.isSubscriptionFilterActive) {
          delete query.subscription
          this.$router.push({ query })
        } else {
          query.subscription = 'true'
          this.$router.push({ query })
        }
      })
    },
    toggleShowroomFilter () {
      let query = Object.assign({}, this.$route.query)
      this.$store.dispatch('ui/toggleShowroomFilter').then(() => {
        if (!this.isShowroomFilterActive) {
          delete query.showroom
          this.$router.push({ query })
        } else {
          query.showroom = 'true'
          this.$router.push({ query })
        }
      })
    },
    toggleVideoFilter () {
      let query = Object.assign({}, this.$route.query)
      this.$store.dispatch('ui/toggleVideoFilter').then(() => {
        if (!this.isVideoFilterActive) {
          delete query.video
          this.$router.push({ query })
        } else {
          query.video = 'true'
          this.$router.push({ query })
        }
      })
    },
    isFiltersAreArrays () {
      let filterValues = Object.values(this.filters)
      if (Array.isArray(filterValues[0])) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';

.icon-close {
  font-size: 30px;
}
.margin-bottom {
  margin-bottom: 5px !important;
}
.active-filters-title {
  @media (max-width: 991px) {
    font-size: 10px;
    font-weight: 600;
  }
}

.active-filters {
  display: flex;
  @media (max-width: 991px) {
    &::-webkit-scrollbar {
      display: none;
    }
    &::after {
      content: '';
      height: 30px;
      width: 20px;
      position: fixed;
      right: 16.5%;
    }
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    margin: auto 0;
  }
  .active-label {
    @media (max-width: 991px) {
      white-space: nowrap;
      // margin-bottom: 0;
    }
  }
}
</style>
